export default __webpack_public_path__ + "fonts/SanFranciscoDisplay-Bold.a26b39482d7d2c571f1ff8ea998fec25.woff";